const esAR = {
  'app.name': 'Compliance Engine',
  'auth.login.title': 'Compliance Engine',
  'auth.login.email': 'Email',
  'auth.login.password': 'Contraseña',
  'auth.login.totp': 'Código 2FA',
  'auth.login.submit': 'Iniciar sesión',
  'auth.login.forgot': '¿Olvidaste tu contraseña?',
  'auth.login.error.invalid': 'Credenciales inválidas',
  'auth.login.error.totp': 'Ingresá tu código 2FA',
  'theme.toggle': 'Cambiar tema claro/oscuro',
  'nav.open': 'Abrir menú de navegación',
} as const;

export type I18nKey = keyof typeof esAR;

export function t(key: I18nKey, fallback?: string): string {
  return esAR[key] ?? fallback ?? key;
}
